<div fxLayout="column" fxFlexFill fxLayoutGap="6px">

  <section fxLayout="column" fxLayoutGap="8px">

    <p>During your trial you:</p>

    <ul>
      <li>Can upload files w/ no limit</li>
      <li>Can only have ONE Roster Sync Job</li>
      <li>Can perform sync analysis with NO EXECUTION (inc. no automation settings)</li>
      <li>Can add roster exceptions</li>
      <li>Cannot manually add Guardians</li>
      <li>Can manually perform analysis of the Guardian sync job (no execution of changes)</li>
    </ul>

  </section>

</div>
